import { Link } from "@mui/material";
import { useContext } from "react";
import { FieldProps, useRecordContext } from "react-admin";
import { useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../OpenTabsContext";
import useNotify from "../unit/useNotify";

const ApplicationLinkField = (_: FieldProps) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { openGlobalTabs } = useContext(OpenTabsContext);
  const navigate = useNavigate();
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  const handleClick = (id: any, loannum: any) => {
    if (openGlobalTabs.length >= 6) {
      if (openGlobalTabs.includes("app-" + id + "-" + loannum)) {
        navigate(`/applicationSummary/` + id + "?loannum=" + loannum);
      } else {
        errorNotify("Cannot open more than 6 tabs.");
        return false;
      }
    } else {
      navigate(`/applicationSummary/` + id + "?loannum=" + loannum);
    }
  };

  return (
    <Link
      component="span"
      id={`application-list-link-${record.id}`}
      onClick={() => handleClick(record.id, record.sLoanNum)}
      className="numericText application-list-link"
      underline="none"
      sx={{
        cursor: "pointer",
        textDecoration: "none",
        "&.RaLink-link": {
          color: "#1976d2",
        },
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {record.id}
    </Link>
  );
};

export default ApplicationLinkField;
